import { EGGSHELL } from "@ui/tokens/pageColors";
import type { VariantProps } from "class-variance-authority";

import { cva } from "class-variance-authority";

const markerDotVariants = cva(
  "tw-absolute tw-z-20 tw-flex tw-size-5 tw-items-center tw-justify-center tw-rounded-full",
  {
    variants: {
      position: {
        topLeft: "tw-left-0 tw-top-0 -tw-translate-x-1/2 -tw-translate-y-1/2",
        topRight: "tw-right-0 tw-top-0 -tw-translate-y-1/2 tw-translate-x-1/2",
        topCentered: "tw-top-0 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2",
        bottomLeft: "tw-bottom-0 tw-left-0 -tw-translate-x-1/2 tw-translate-y-1/2",
        bottomRight: "tw-bottom-0 tw-right-0 tw-translate-x-1/2 tw-translate-y-1/2",
        bottomCentered: "tw-bottom-0 tw-left-1/2 -tw-translate-x-1/2 tw-translate-y-1/2",
      },
    },
    defaultVariants: {
      position: "topLeft",
    },
  },
);

export const CornerMarkerDot = ({
  backgroundColor = EGGSHELL,
  position,
}: {
  backgroundColor?: string;
} & VariantProps<typeof markerDotVariants>) => {
  return (
    <div
      className={markerDotVariants({ position })}
      style={{ backgroundColor: `var(--marker-background-color, ${backgroundColor})` }}
    >
      <div className='tw-rounded-full tw-bg-black tw-size-0.5' />
    </div>
  );
};
